<template>
    <page-container>
        <template v-slot:page-fixed-header>
          <span class="text-h5 font-weight-bold ml-3 full-width page-header">{{
          $t("menu.businessManagement")
        }}</span>
          <v-spacer></v-spacer>
          <div style="height:40px;"/>
        </template>
        <template v-slot:page-content>
          <BusinessManagementAnalysis />
        </template>
    </page-container>
</template>

<script>
import BusinessManagementAnalysis from './BusinessManagementAnalysis.vue';

export default {
    name: "BusinessManagementPage",
    components: {
      BusinessManagementAnalysis
    }
}
</script>

<style>
::v-deep .container--fluid {
  padding: 0px !important;
}
.v-main {
  /* background: var(--v-Neutral-base) !important; */
  background: red !important;
  padding-top: 105px !important;
}
</style>